import { apiClient } from '../config/api';

// FEAT-057 — Save / Favorite Caregivers (MVP-18.29). Client-side service for
// the auth-gated favorites API. Favoriting requires authentication: callers
// must gate on auth before invoking these methods (the API itself rejects
// unauthenticated requests with 401).

export interface FavoriteCaregiverSummary {
  id: string;
  firstName: string | null;
  lastName: string | null;
  avatar: string | null;
  bio?: string | null;
  location?: string | null;
  hourlyRate?: number | null;
  yearsExperience?: number | null;
  languages?: string[];
}

export interface FavoriteCaregiver {
  id: string;
  caregiverId: string;
  createdAt: string;
  caregiver: FavoriteCaregiverSummary;
}

interface FavoriteResponse {
  data: FavoriteCaregiver;
}

interface RemoveFavoriteResponse {
  data: {
    caregiverId: string;
    removed: boolean;
  };
}

interface ListFavoritesResponse {
  data: FavoriteCaregiver[];
}

class FavoritesService {
  /** Add a caregiver to the authed careseeker's favorites (idempotent). */
  async addFavorite(caregiverId: string): Promise<FavoriteCaregiver> {
    const response = await apiClient.post<FavoriteResponse>(`/favorites/${caregiverId}`);
    return response.data.data;
  }

  /** Remove a caregiver from favorites (idempotent). */
  async removeFavorite(caregiverId: string): Promise<{ caregiverId: string; removed: boolean }> {
    const response = await apiClient.delete<RemoveFavoriteResponse>(`/favorites/${caregiverId}`);
    return response.data.data;
  }

  /** List the authed careseeker's favorited caregivers, newest first. */
  async listFavorites(): Promise<FavoriteCaregiver[]> {
    const response = await apiClient.get<ListFavoritesResponse>('/favorites');
    return response.data.data;
  }
}

export const favoritesService = new FavoritesService();
